import React from "react";
import ProgressBar from "../Misc/ProgressBar";

const TotalsSummary = ({ props }) => {
  return (
    <div className="flex flex-col h-[10rem] items-center justify-center gap-2 bg-white text-white rounded-md p-8 w-full dark:bg-gray-500">
      {props.totals.map((el, index) => {
        return (
          <div className="w-full flex flex-col" key={index}>
            <span className="text-black dark:text-white">{`$${el.total.toLocaleString()}/${el.goal.toLocaleString()} ${
              el.title
            }`}</span>
            <ProgressBar
              completed={(el.total / el.goal).toFixed(2) * 100}
              bgColor={el.background}
              total={el.total}
              goal={el.goal}
            />
          </div>
        );
      })}
    </div>
  );
};

export default TotalsSummary;
